/** The business calendar for date-effective rules (rate windows, "valid from"): Sydney, matching the backend. */
export const BUSINESS_TIME_ZONE = "Australia/Sydney";

const formatter = new Intl.DateTimeFormat("en-CA", {
	timeZone: BUSINESS_TIME_ZONE,
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
});

/** YYYY-MM-DD for the instant in the business timezone. */
export const businessDate = (date: Date): string => {
	const parts = formatter.formatToParts(date);
	const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? "";
	return `${get("year")}-${get("month")}-${get("day")}`;
};

export const businessToday = (): string => businessDate(new Date());
